import React from 'react'

import { deleteEvent } from '../../api/events'
import EventCard from '../../components/EventCard'

const Event = ({ campaignId, created, description, displayName, id, isDarkMode, event }) => {
  const [ loading, setLoading ] = React.useState(false)

  if (Object.keys(event).length === 0) return false

  const onDelete = async () => {
    setLoading(true)
    try {
      await deleteEvent(campaignId, id)
    } catch(e) {
      console.log(e)
      setLoading(false)
    }
  }

  return (
    <EventCard
      campaignId={campaignId}
      created={created}
      description={description}
      displayName={displayName}
      id={id}
      isDarkMode={isDarkMode}
      isEvent
      loading={loading}
      setLoading={setLoading}
      onDelete={onDelete}
    >
      <div css={`text-align: left; padding: 6px; white-space: pre; overflow: auto;`}>
        {event?.text}
      </div>
    </EventCard>
  )
}

export default Event
